export default __webpack_public_path__ + "static/media/loading.b61d16b5.gif";